import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index'),
    },{
      path: '/admin',
      name: 'AdminIndex',
      component: () => import('@/views/admin/index'),
    },{
      path: '/success',
      name: 'Success',
      component: () => import('@/views/subscribe/success'),
    },{
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/index'),
    }
  ]
})

// 解决 反复切换页面时的错误：Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};



// WEBPACK FOOTER //
// ./src/router/index.js